<template>
  <div class="app-container">
    <div class="right">
      <el-button type="primary" @click="addVersion">新增版本</el-button>
    </div>
    <el-table :data="tableData" class="mt20" :loading="loading">
      <el-table-column label="版本" prop="version"></el-table-column>
      <el-table-column label="下载地址" prop="downloadUrl">
        <template v-slot="{row}">
          <!-- <el-popconfirm v-if="row.updateType === 2"
            title="确定下载?"
            @onConfirm="download(row)"
          >
            <el-button type="text" slot="reference">{{row.apkFileInfo.name}}</el-button>
          </el-popconfirm> -->
          <el-link type="primary" v-if="row.apkFileInfo" :href="row.apkFileInfo.url" target="_blank">{{ row.apkFileInfo.name }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="版本类型" prop="clientTypeDesc"/>
      <el-table-column label="更新类型" prop="updateTypeDesc"/>
      <el-table-column label="更新描述" prop="updateContent"/>
      <el-table-column label="更新时间" prop="updateTime">
        <template v-slot="{row}">
          {{ row.updateTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{row}">
            <el-button slot="reference" type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button slot="reference" type="text" @click="del(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <el-dialog title="版本" :visible.sync="addVersionFlag" width="600px">
      <el-form ref="versionFormEl" :model="versionForm" :rules="versionRules" label-width="100px">
        <el-form-item label="版本号" prop="version">
          <el-input v-model="versionForm.version" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="更新描述" prop="updateContent">
          <el-input type="textarea" placeholder="请输入" :maxlength="50" v-model="versionForm.updateContent"></el-input>
        </el-form-item>
        <el-form-item label="版本类型" prop="clientTypeList">
            <el-checkbox-group v-model="versionForm.clientTypeList">
                <el-checkbox label="2">安卓客户端</el-checkbox>
                <el-checkbox label="1">IOS客户端</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="下载地址" prop="fileObjs" ref="imgref" v-if="versionForm.clientTypeList.indexOf('2') > -1">
          <el-upload
            class="upload-demo"
            accept=".apk"
            :action="uploadUrl"
            :headers="headers"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :limit="1"
            :file-list="versionForm.fileObjs">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传apk文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="更新类型" prop="updateType">
          <el-radio-group v-model="versionForm.updateType">
            <el-radio :label="1">更新</el-radio>
            <el-radio :label="2">强制更新</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVersionFlag = false">取消</el-button>
        <el-button @click="confirmAdd" type="primary">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryAppVersionList,
  addAppVersion,
  delAppVersion
} from '@/api/version/index'
import {getToken} from "@/utils/auth"

export default {
  data() {
    return {
      addVersionFlag: false,
      loading: false,
      versionForm: {
        fileObjs: [],
        downloadUrl: '',
        updateContent: '',
        updateType: 1,
        clientTypeList:['2'],
        version: ''
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableData: []
    }
  },
  watch: {
    addVersionFlag(v) {
      if (!v) {
        this.resetFormValue()
      }
    }
  },
  computed: {
    uploadUrl() {
      return process.env.VUE_APP_BASE_API + "/upload/"
    },
    headers() {
      return {'Authorization': getToken(), 'x-domain-key': 'admin', 'Terminal-Type': 'PC', platform: 'pc'}
    },
    versionRules() {
      return {
        downloadUrl: [
          {required: true, message: '请输入', trigger: 'change'}
        ],
        updateContent: [
          {required: true, message: '请输入', trigger: 'change'}
        ],
        updateType: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        clientTypeList: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        fileObjs: [
          {
            required: true,
            message: '请上传',
            trigger: 'change'
          }
        ],
        version: [
          {required: true, message: '请输入', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList(page) {
      this.loading = true
      queryAppVersionList(this.queryParams).then(res => {
        this.total = res.data.total || 0
        this.tableData = res.data.rows || []
        this.loading = false
      })
    },
    handleSuccess(res, file, fileList) {
      if (res.url) {
        this.versionForm.fileObjs.push(res)
        this.$refs.imgref.clearValidate()
      } else {
        this.$message.error(res.msg)
        this.versionForm.fileObjs = []
      }
    },
    handleRemove(file, fileList) {
      this.versionForm.fileObjs = []
      // this.versionForm.fileObjs = fileList
      // console.log(file, fileList)
    },
    handleExceed() {
      this.$message.warning('最多上传一个文件')
    },
    addVersion() {
      this.addVersionFlag = true
      delete this.versionForm.id
    },
    confirmAdd() {
      this.$refs.versionFormEl.validate(valid => {
        if (valid) {
            this.versionForm.apkFileId = this.versionForm.fileObjs.length && this.versionForm.fileObjs[0].id;
            addAppVersion({
                ...this.versionForm
            }).then(res => {
                if (res.code == 200) {
                    this.addVersionFlag = false
                    this.queryList()
                }
            })
        }
      })
    },
    updateVersion(param) {
      const result = Object.assign(this.versionForm, param)
      updateAppVersion(result).then(res => {
        if (res.code == 200) {
          this.addVersionFlag = false
          this.queryList()
        }
      })
    },
    download(row) {
      window.open(row.apkFileInfo.url, '_blank')
    },
    handleEdit(row) {
        this.versionForm = JSON.parse(JSON.stringify(row))
        this.versionForm.fileObjs = row.apkFileInfo ? [row.apkFileInfo] : []
        this.addVersionFlag = true
    },
    async del(row) {
      let that = this
        this.$confirm('是否确认删除该数据?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          delAppVersion({
              id: row.id
          }).then(res => {
              if (res.code == 200) {
                  that.queryList()
              }
          })
        })
    },
    resetFormValue() {
        this.versionForm = {
            fileObjs: [],
            downloadUrl: '',
            updateContent: '',
            updateType: 1,
            clientTypeList:['2'],
            version: ''
        }
        this.resetForm("versionFormEl");
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
